import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { ClientPoints, ClientPointsRequest, IPayment, IPaymentRequest } from "@ontime/types";

const API_URL = (organizationId: string, appointmentId: string) => `${ApiURL()}/organizations/${organizationId}/appointment/${appointmentId}/Payment`;


// [Route("organizations/{organizationId}/appointment/{appointmentId}/payment")]

class PaymentService {

    async GetList(organizationId: string, appointmentId: string, showDeleted: boolean = false): Promise<IPayment[]> {
        const response = await axios.get<IPayment[]>(API_URL(organizationId, appointmentId), {
            headers: AuthHeader(),
            params: { showDeleted }
        });
        return response.data;
    }

    async Get(organizationId: string, appointmentId: string, paymentId: string): Promise<IPayment> {
        const response = await axios.get<IPayment>(`${API_URL(organizationId, appointmentId)}/${paymentId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }
    //todo
    async GetClientPoints(input: ClientPointsRequest): Promise<ClientPoints> {
        const response = await axios.get<ClientPoints>(`${API_URL(input.organizationId, input.appointmentId ?? '')}/${input.paymentId}/GetClientPoints`, {
            headers: AuthHeader(),
            params: { clientId: input.clientId },
        });
        return response.data;
    }

    async Create(organizationId: string, appointmentId: string, input: IPaymentRequest): Promise<IPayment> {
        const response = await axios.post<IPayment>(API_URL(organizationId, appointmentId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Update(organizationId: string, appointmentId: string, input: IPaymentRequest): Promise<IPayment> {
        const response = await axios.put<IPayment>(API_URL(organizationId, appointmentId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Delete(organizationId: string, appointmentId: string, PaymentId: string, currentIsDeleted: boolean): Promise<{ PaymentId: string }> {
        const response = await axios.delete<{ PaymentId: string }>(`${API_URL(organizationId, appointmentId)}/${PaymentId}`, {
            headers: AuthHeader(),
            params: { currentIsDeleted }
        });
        return response.data;
    }
}

export default new PaymentService();